import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import RadioComponent from '../components/Radio';

export type StrategyCardTheme = 'red' | 'blue' | 'green';

const themeConfig: Record<
  StrategyCardTheme,
  {
    border: string;
    selectedBorder: string;
    bg: string;
    radioColor: string;
    badgeBg: string;
    badgeColor: string;
    badgeBorder: string;
  }
> = {
  red: {
    border: '#D81010',
    selectedBorder: '#D81010',
    bg: '#F614141A',
    radioColor: '#D81010',
    badgeBg: '#F614141A',
    badgeColor: '#D81010',
    badgeBorder: '#D81010',
  },
  blue: {
    border: '#537EFF',
    selectedBorder: '#537EFF',
    bg: '#537EFF1A',
    radioColor: '#537EFF',
    badgeBg: '#537EFF1A',
    badgeColor: '#537EFF',
    badgeBorder: '#537EFF',
  },
  green: {
    border: '#0EAB4E',
    selectedBorder: '#0EAB4E',
    bg: '#0EAB4E1A',
    radioColor: '#0EAB4E',
    badgeBg: '#0EAB4E1A',
    badgeColor: '#0EAB4E',
    badgeBorder: '#0EAB4E',
  },
};

type ResolutionStrategyCardProps = {
  value: string;
  selected: boolean;
  title: string;
  description: string;
  badge: string;
  colorTheme: StrategyCardTheme;
  onChange: (value: string) => void;
};

const ResolutionStrategyCard = ({
  value,
  selected,
  title,
  description,
  badge,
  colorTheme,
  onChange,
}: ResolutionStrategyCardProps) => {
  const cfg = themeConfig[colorTheme];

  return (
    <Box
      onClick={() => onChange(value)}
      sx={{
        cursor: 'pointer',
        border: `1.5px solid ${selected ? cfg.selectedBorder : cfg.border}`,
        borderRadius: '10px',
        backgroundColor: cfg.bg,
        p: '11px 16px',
        display: 'flex',
        flexDirection: 'column',
        transition: 'border-color 0.15s',
        userSelect: 'none',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', lineHeight: '100%' }}>
        <RadioComponent
          checked={selected}
          onChange={() => onChange(value)}
          value={value}
          onClick={(e: any) => e.stopPropagation()}
          sx={{
            p: 0,
          }}
        />
        <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: '#434D67' }}>
          {title}
        </Typography>
      </Box>

      <Typography sx={{ mt: '15px', fontSize: '0.875rem', fontWeight: 400, color: '#434D67', lineHeight: '100%' }}>
        {description}
      </Typography>

      <Box
        sx={{
          mt: '15px',
          alignSelf: 'flex-start',
          border: `1px solid ${cfg.badgeBorder}`,
          borderRadius: '3px',
          backgroundColor: cfg.badgeBg,
          p: '1px 16px',
        }}
      >
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 400, color: cfg.badgeColor, lineHeight: '24px' }}>
          {badge}
        </Typography>
      </Box>
    </Box>
  );
};

export default memo(ResolutionStrategyCard);
